export default {
    /* GET_JOBS
    ---------------------------------------------------------------
    */
    GET_JOBS_REQUEST: state => {
        state.jobsLoading = true
    },
    GET_JOBS_SUCCESS: (state, data) => {
        state.jobs = data.results
        state.jobsLoading = false
    },
    GET_JOBS_FAILURE: state => {
        state.jobsLoading = false
    },
    GET_JOB_PLATES_REQUEST: state => {
        state.jobPlatesLoading = true
    },
    GET_JOB_PLATES_SUCCESS: (state, data) => {
        state.jobPlates = data.results
        state.jobPlatesLoading = false
    },
    GET_JOB_PLATES_FAILURE: state => {
        state.jobPlatesLoading = false
    },
    CLEAR_JOBS_PLATES: state => {
        state.jobPlates = []
    },
    GET_AGGREGATED_JOBS_SUCCESS: (state, data) => {
        state.machines = data.map(item => (
            state.filters.machineIds.includes(item.machineId) ? {...item, isSelected: true} : {...item, isSelected: false}
        ))
    },
    SET_JOBS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_JOBS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}